// export const AnswerObject = [
//   {

//     selfAttendance: true,

//     studentAttendanceCount: {
//       count9: 0,
//       Ajay: false,
//       Jatin: false,
//       count10: 0,
//       Samay: false,
//       Anjali: false,
//     },

//     uploadMarksCount: {
//       Shubham: 1,
//       Ripudaman: 1,
//       Sanjeev: 1,
//       Ajay: 0,
//       Jatin: 1,
//       Poshak: 1,
//       Anshu: 1,
//       Gajendra: 1,
//       Vimal: 1,
//       Madhu: 1,
//       Akhilesh: 1,
//       Abhinesh: 1,
//       Akshay: 1,
//       Samay: 0,
//       Anjali: 1,
//       Rekha: 1,
//       Srishti: 1,
//       Aayush: 1,
//       Jay: 1,
//       Rohit: 1,
//       Priyanka: 1,
//       Arjun: 1,
//       Kartik: 1,
//       Aalia: 1,
//       Shally: 1,
//       Ritu: 1,
//       Jagjeet: 1,
//       Natasha: 1,
//       Mohit: 1,
//       Sandeep: 1,
//     },

//     disciplinary: {
//       Aalia: ["Late Arrival", 0.5],
//       Ajay: ["Absenteeism", 0.5],
//       Aayush: ["Using Mobile Phone", 0.5],
//       Abhinesh: ["Talking", 0.5],
//       Akhilesh: ["Leaving Class", 0.5],
//     },

//     copyChecking: {
//       Aalia: [
//         { English: "Complete", status: "Class Work" },
//         { Hindi: "Incomplete", status: "Class Work" },
//         { Maths: "Unavailable", status: "Class Work" },
//         {mark: 0.5}
//       ],
//       Ajay: [
//         { English: "Incomplete", status: "Class Work" },
//         { Hindi: "Complete", status: "Class Work" },
//         { Maths: "Unavailable", status: "Class Work" },
//         { Science: "Complete", status: "Class Work" },
//         { "S.St": "Complete", status: "Class Work" },
//         {mark: 0.5}
//       ],
//       Aayush: [
//         { English: "Complete", status: "Class Work" },
//         { Hindi: "Incomplete", status: "Class Work" },
//         { Science: "Unavailable", status: "Class Work" },
//         {mark: 0.5}
//       ],
//       Abhinesh: [
//         { English: "Complete", status: "Class Work" },
//         { Hindi: "Incomplete", status: "Class Work" },
//         { Maths: "Unavailable", status: "Class Work" },
//         {mark: 0.5}
//       ],
//       Akhilesh: [
//         { English: "Incomplete", status: "Class Work" },
//         { Hindi: "Complete", status: "Class Work" },
//         { Maths: "Unavailable", status: "Class Work" },
//         { Science: "Complete", status: "Class Work" },
//         { "S.St": "Complete", status: "Class Work" },
//         {mark: 0.5}
//       ],
//     },

//     downloadAttendancePdfFormat: true,
//     uploadAttendancePdfFormat: true,

//     schoolConcern: {
//       concerns: [
//         { concern: "School", remark: "Class Interrupted", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "School", remark: "Optional Class", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "School", remark: "Question Paper Checking", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "School", remark: "School Closed", classOfConcern: "10", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "School", remark: "School Half-Day", classOfConcern: "10", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//       ],
//     },

//     studentRelatedConncern: {
//       concerns: [
//         { concern: "Student", remark: "Add Student on ERP", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Student", remark: "SLC Released, Remove", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Student", remark: "Center Change", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14" },
//         { concern: "Student", remark: "MB App not working", classOfConcern: "10", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Student", remark: "Add Student on ERP", classOfConcern: "10", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//       ],
//     },

//     techConcern: {
//       concerns: [
//         { concern: "Screen", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Inverter", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Microphone", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         // { concern: "Internet", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14" },
//         { concern: "Camera", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Mini_PC", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//         { concern: "Electricity", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark:0.5 },
//       ],
//     },

//     absenteeCalling: {
//       students: [
//         { studentSrn: "1111112954", studentName: "Ajay", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:49.264Z", mark:0.5 },
//         { studentSrn: "1111112941", studentName: "Jatin", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:52.811Z", mark:0.5 },
//         { studentSrn: "1111111400", studentName: "Samay", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:56.025Z", mark:0.5 },
//         { studentSrn: "1111111400", studentName: "Anjali", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:56.025Z" , mark:0.5},
//       ],
//     },

//     "closeSchoolConcerns": {
//     "concerns": [

// {
//         "concernId": "68ed6fc628cb28ed8072c9bd",
//         "concern": "School",
//         "remark": "Class Interrupted",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": null,
//         "status": "Still Not Resolved",
//         "comment": "asd",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:35:51.226Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },

// {
//         "concernId": "68ed6fc628cb28ed8072c9bd",
//         "concern": "School",
//         "remark": "Optional Class",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": null,
//         "status": "Still Not Resolved",
//         "comment": "asd",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:35:51.226Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },

// {
//         "concernId": "68ed6fc628cb28ed8072c9bd",
//         "concern": "School",
//         "remark": "Question Paper Checking",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "asd",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:35:51.226Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed6fc628cb28ed8072c9bd",
//         "concern": "School",
//         "remark": "School Closed",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "asd",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:35:51.226Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed6fc628cb28ed8072c9bd",
//         "concern": "School",
//         "remark": "School Half-Day",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "asd",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:35:51.226Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },



// ]
//   },
//   "closeStudentConcerns": {
//     "concerns": [{
//         "concernId": "68ed7638ecae1a21d3c6e8cd",
//         "concern": "Student",
//         "remark": "Add student on ERP",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": "1231231313",
//         "status": "Resolved",
//         "comment": "vsdgf",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:49:20.429Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed7638ecae1a21d3c6e8cd",
//         "concern": "Student",
//         "remark": "SLC Released, Remove",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": "1231231313",
//         "status": "Resolved",
//         "comment": "vsdgf",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:49:20.429Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed7638ecae1a21d3c6e8cd",
//         "concern": "Student",
//         "remark": "Center Change",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": "1231231313",
//         "status": "Resolved",
//         "comment": "vsdgf",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:49:20.429Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed7638ecae1a21d3c6e8cd",
//         "concern": "Student",
//         "remark": "MB App not working",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": "1231231313",
//         "status": "Resolved",
//         "comment": "vsdgf",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:49:20.429Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed7638ecae1a21d3c6e8cd",
//         "concern": "Student",
//         "remark": "Add student on ERP",
//         "classOfConcern": "9",
//         "schoolId": "undefined",
//         "studentSrn": "1231231313",
//         "status": "Resolved",
//         "comment": "vsdgf",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T07:49:20.429Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// ]
//   },
//   "closeTechConcerns": {
//     "concerns": [
//  {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Screen",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },

//  {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Inverter",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Not Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
//  {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Microphone",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
//  {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Internet",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Not Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },

//  {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Camera",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Mini_PC",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Not Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },

// {
//         "concernId": "68ed7646ecae1a21d3c6e8d9",
//         "concern": "Electricity",
//         "remark": "Not working",
//         "classOfConcern": "9",
//         "schoolId": "784",
//         "studentSrn": null,
//         "status": "Resolved",
//         "comment": "Cc",
//         "resolvedBy": "hkrn1",
//         "resolvedAt": {
//           "$date": "2025-10-14T08:39:30.920Z"
//         },
//         "dateOfSubmission": "2025-10-14"
//       },
// ]


//     marks: {
//       q1: 0.5, q2: 2, q3: 3.6, q4: 2.5, q5: 2.5, q6: 0.5, q7: 0.5, q8: 2.5,
//       q9: 2.5, q10: 3, q11: 2, q12: 2.5, q13: 2.5, q14: 3, isTestSubmitted: true,
//     },


//   },
// ];









export const AnswerObject = [
  {
    selfAttendance: true, //if true, then 1.5 mark

    studentAttendanceCount: {
      count9: 0, //If count equals 13 then, 0.5 marks
      Ajay: false, //0.25 if stays false if true, then negative -0.25
      Jatin: false,//0.25 if stays false if true, then negative -0.25
      count10: 0, //if count equeals 13, then, 0.5 marks
      Samay: false,//0.25 if stays false if true, then negative -0.25
      Anjali: false,//0.25 if stays false if true, then negative -0.25, 
      //But in this field if sum of count9 + count10 does not equal to 26 then 0 marks
    },

    uploadMarksCount: {
      Shubham: 1, 
      Ripudaman: 1, 
      Sanjeev: 1, 
      Ajay: 0, 
      Jatin: 1, 
      Poshak: 1, 
      Anshu: 1, 
      Gajendra: 1, 
      Vimal: 1, 
      Madhu: 1, 
      Akhilesh: 1, 
      Abhinesh: 1, 
      Akshay: 1, 
      Samay: 0, 
      Anjali: 1, 
      Rekha: 1, 
      Srishti: 1, 
      Aayush: 1, 
      Jay: 1, 
      Rohit: 1, 
      Priyanka: 1, 
      Arjun: 1, 
      Kartik: 1, 
      Aalia: 1, 
      Shally: 1, 
      Ritu: 1, 
      Jagjeet: 1, 
      Natasha: 1, 
      Mohit: 1, 
      Sandeep: 1, 
        //This field will be of total four marks.
      //In this field if Ajay and Samay has 0 value and all ther field has 1 that means give total 4 marks
      //if lets say Samay and Ajay also has 1 that means it is wrong and per mistake gets -0.5, and if total 1 are not 18 
      //...but Ajay and Samay still 0 then no marks
    },

    disciplinary: {
      Aalia: ["Late Arrival", 0.5],
      Ajay: ["Absenteeism", 0.5],
      Aayush: ["Using Mobile Phone", 0.5],
      Abhinesh: ["Talking", 0.5],
      Akhilesh: ["Leaving Class", 0.5],
    },

    copyChecking: {
      Aalia: [
        { English: "Complete", status: "Class Work" },
        { Hindi: "Incomplete", status: "Class Work" },
        { Maths: "Unavailable", status: "Class Work" },
        { mark: 0.5 },
      ],
      Ajay: [
        { English: "Incomplete", status: "Class Work" },
        { Hindi: "Complete", status: "Class Work" },
        { Maths: "Unavailable", status: "Class Work" },
        { Science: "Complete", status: "Class Work" },
        { "S.St": "Complete", status: "Class Work" },
        { mark: 0.5 },
      ],
      Aayush: [
        { English: "Complete", status: "Class Work" },
        { Hindi: "Incomplete", status: "Class Work" },
        { Science: "Unavailable", status: "Class Work" },
        { mark: 0.5 },
      ],
      Abhinesh: [
        { English: "Complete", status: "Class Work" },
        { Hindi: "Incomplete", status: "Class Work" },
        { Maths: "Unavailable", status: "Class Work" },
        { mark: 0.5 },
      ],
      Akhilesh: [
        { English: "Incomplete", status: "Class Work" },
        { Hindi: "Complete", status: "Class Work" },
        { Maths: "Unavailable", status: "Class Work" },
        { Science: "Complete", status: "Class Work" },
        { "S.St": "Complete", status: "Class Work" },
        { mark: 0.5 },
      ],
    },

    downloadAttendancePdfFormat: true,  //if true then 1 mark
    uploadAttendancePdfFormat: true, //if true then 1 mark

    schoolConcern: {
      concerns: [
        { concern: "School", remark: "Class Interrupted", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "School", remark: "Optional Class", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "School", remark: "Question Paper Checking", classOfConcern: "9", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "School", remark: "School Closed", classOfConcern: "10", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "School", remark: "School Half-Day", classOfConcern: "10", comment: "aslkfj", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
      ],
    },

    studentRelatedConncern: {
      concerns: [
        // { concern: "Student", remark: "Add Student on ERP", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Student", remark: "SLC Released, Remove", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Student", remark: "Center Change", classOfConcern: "9", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Student", remark: "MB App not working", classOfConcern: "10", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Student", remark: "Add Student on ERP", classOfConcern: "10", studentSrn: "8768687687", comment: "slkfdf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
      ],
    },

    techConcern: {
      concerns: [
        { concern: "Screen", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Inverter", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Microphone", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        // { concern: "Internet", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14" },
        { concern: "Camera", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Mini_PC", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
        { concern: "Electricity", remark: "Not working", comment: "asdkf", createdBy: "hkrn1", dateOfSubmission: "2025-10-14", mark: 0.5 },
      ],
    },

    absenteeCalling: {
      students: [
        { studentSrn: "1111112954", studentName: "Ajay", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:49.264Z", mark: 0.5 },
        { studentSrn: "1111112941", studentName: "Jatin", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:52.811Z", mark: 0.5 },
        { studentSrn: "1111111400", studentName: "Samay", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:56.025Z", mark: 0.5 },
        { studentSrn: "1111111400", studentName: "Anjali", status: "Connected", updatedBy: "hkrn1", updatedAt: "2025-10-14T04:29:56.025Z", mark: 0.5 },
      ],
    },

    closeSchoolConcerns: {
      concerns: [
        {
          concernId: "68ed6fc628cb28ed8072c9bd",
          concern: "School",
          remark: "Class Interrupted",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: null,
          status: "Still Not Resolved",
          comment: "asd",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:35:51.226Z",
          },
          dateOfSubmission: "2025-10-14",
           mark: 0.5
        },
        {
          concernId: "68ed6fc628cb28ed8072c9bd",
          concern: "School",
          remark: "Optional Class",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: null,
          status: "Still Not Resolved",
          comment: "asd",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:35:51.226Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed6fc628cb28ed8072c9bd",
          concern: "School",
          remark: "Question Paper Checking",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: null,
          status: "Resolved",
          comment: "asd",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:35:51.226Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed6fc628cb28ed8072c9bd",
          concern: "School",
          remark: "School Closed",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: null,
          status: "Resolved",
          comment: "asd",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:35:51.226Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed6fc628cb28ed8072c9bd",
          concern: "School",
          remark: "School Half-Day",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: null,
          status: "Resolved",
          comment: "asd",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:35:51.226Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
      ],
    },

    closeStudentConcerns: {
      concerns: [
  
        {
          concernId: "68ed7638ecae1a21d3c6e8cd",
          concern: "Student",
          remark: "SLC Released, Remove",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: "1231231313",
          status: "Still Not Resolved",
          comment: "vsdgf",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:49:20.429Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7638ecae1a21d3c6e8cd",
          concern: "Student",
          remark: "Center Change",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: "1231231313",
          status: "Resolved",
          comment: "vsdgf",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:49:20.429Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7638ecae1a21d3c6e8cd",
          concern: "Student",
          remark: "MB App not working",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: "1231231313",
          status: "Resolved",
          comment: "vsdgf",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:49:20.429Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7638ecae1a21d3c6e8cd",
          concern: "Student",
          remark: "Add student on ERP",
          classOfConcern: "9",
          schoolId: "undefined",
          studentSrn: "1231231313",
          status: "Still Not Resolved",
          comment: "vsdgf",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T07:49:20.429Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
      ],
    },

    closeTechConcerns: {
      concerns: [
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Screen",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Inverter",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Not Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Microphone",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Camera",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Mini_PC",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Not Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
        {
          concernId: "68ed7646ecae1a21d3c6e8d9",
          concern: "Electricity",
          remark: "Not working",
          classOfConcern: "9",
          schoolId: "784",
          studentSrn: null,
          status: "Resolved",
          comment: "Cc",
          resolvedBy: "hkrn1",
          resolvedAt: {
            $date: "2025-10-14T08:39:30.920Z",
          },
          dateOfSubmission: "2025-10-14",
          mark: 0.5
        },
      ],
    },

   
  },
];
